// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gRJV","newExpiryDate":"styles_newExpiryDate__2Th4t","footer":"styles_footer__1e7Jj"};